import React from 'react';
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SectionHeader from './SectionHeader';
import CharCount from './CharCount';
import { CHAR_LIMIT, textFieldSx } from './constants';

const OpenDoorContactSection = ({
  companyName,
  form,
  onFieldChange,
  onGenerate,
  isGenerating,
  canGenerate,
}) => (
  <Box
    border={1}
    borderColor='divider'
    borderRadius={2}
    p={2.5}
    display='flex'
    flexDirection='column'
    minHeight={{ md: 640 }}
  >
    <SectionHeader number={1} title='Tell me about your contact' />

    <TextField
      fullWidth
      size='small'
      label='Full name'
      placeholder='Jane Smith'
      value={form.fullName}
      onChange={onFieldChange('fullName')}
      sx={textFieldSx}
    />
    <TextField
      fullWidth
      size='small'
      label='Company'
      placeholder='Adidas'
      value={form.company}
      onChange={onFieldChange('company')}
      sx={textFieldSx}
    />
    <TextField
      fullWidth
      size='small'
      label='Title (optional)'
      placeholder='VP Digital Commerce'
      value={form.title}
      onChange={onFieldChange('title')}
      sx={textFieldSx}
    />
    <TextField
      fullWidth
      size='small'
      label='LinkedIn profile (optional)'
      placeholder='https://linkedin.com/in/…'
      value={form.linkedin}
      onChange={onFieldChange('linkedin')}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <LinkedInIcon sx={{ color: '#0a66c2', fontSize: 20 }} />
          </InputAdornment>
        ),
      }}
      sx={textFieldSx}
    />

    <Typography variant='body2' fontWeight={600} mb={0.75} mt={0.5}>
      How do you know this person?
    </Typography>
    <TextField
      fullWidth
      multiline
      minRows={2}
      placeholder='Met at a conference, introduced by a mutual contact, etc.'
      value={form.howDoYouKnowThisPerson}
      onChange={onFieldChange('howDoYouKnowThisPerson')}
      inputProps={{ maxLength: CHAR_LIMIT }}
      sx={{ ...textFieldSx, mb: 0 }}
    />
    <CharCount value={form.howDoYouKnowThisPerson} />

    <Typography variant='body2' fontWeight={600} mb={0.75} mt={1}>
      Why do you think {companyName} could be relevant?
    </Typography>
    <TextField
      fullWidth
      multiline
      minRows={2}
      placeholder={`Share why ${companyName} might help this prospect…`}
      value={form.whyClientRelevant}
      onChange={onFieldChange('whyClientRelevant')}
      inputProps={{ maxLength: CHAR_LIMIT }}
      sx={{ ...textFieldSx, mb: 0 }}
    />
    <CharCount value={form.whyClientRelevant} />

    <Typography variant='body2' fontWeight={600} mb={0.75} mt={1}>
      Anything else I should know?
    </Typography>
    <TextField
      fullWidth
      multiline
      minRows={2}
      placeholder='Context, timing, tone preferences…'
      value={form.anythingElse}
      onChange={onFieldChange('anythingElse')}
      inputProps={{ maxLength: CHAR_LIMIT }}
      sx={{ ...textFieldSx, mb: 0 }}
    />
    <CharCount value={form.anythingElse} />

    <Box mt='auto' pt={2}>
      <Button
        fullWidth
        variant='contained'
        disabled={!canGenerate || isGenerating}
        onClick={onGenerate}
        startIcon={<AutoAwesomeIcon />}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          py: 1.25,
          boxShadow: 'none',
        }}
      >
        {isGenerating ? 'Saving…' : 'Generate introduction'}
      </Button>
      <Box display='flex' alignItems='flex-start' gap={1} mt={1.5}>
        <LockOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary', mt: 0.15 }} />
        <Typography variant='caption' color='text.secondary' sx={{ lineHeight: 1.5 }}>
          Your contact is saved to your Prospect list. AI introduction generation will be connected
          separately.
        </Typography>
      </Box>
    </Box>
  </Box>
);

export default OpenDoorContactSection;
